import BlackoutDefinitionFetcher from './BlackoutDefinitionFetcher';

export default BlackoutDefinitionFetcher;
